import axios from "axios";

const BASE_URL = "api/v1";

export function getAvailableWorkspaces() {
  return axios.get(`${BASE_URL}/users/workspaces`);
}

export function getWorkspace() {
  return axios.get(`${BASE_URL}/workspaces`);
}

export function updateWorkspace(changes) {
  return axios.patch(`${BASE_URL}/workspaces`, changes);
}
